import { rem } from 'polished';
import styled from 'styled-components';

export const StyledLegend = styled.legend`
  margin-bottom: ${({ theme }) => rem(theme.spacings.s)};
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 400;
  line-height: 1.4;
`;
